/**
 * search bar component
 * 
 * @module search-bar
 * @version 1.0.0
 * @extends HTMLElement
 */

 customElements.component = 'search-bar';

 if (!customElements.get(customElements.component)) {
 
     class searchBar extends HTMLElement {

    /**
     * search bar web component
     * 
     * @constructor
     */
    constructor() {

        super();

		this.initCloseEvents();
		this.initOpenEvents();
    }

	/**
	 * start to listen the click button to close search bar
     * 
     * @returns {undefined}
	 */
	initCloseEvents () {

		// Close search bar when click on overlay
		document.querySelector('[data-search-overlay]').addEventListener('click', (event) => {
			event.preventDefault();
			this.close();
		});

		// Close search bar  when click on close button
		this.querySelectorAll('[data-search-close]').forEach( (btn) => {
			btn.addEventListener('click', (event) => {
				event.preventDefault();
				this.close();
			});
		});

		// Close search bar on press escape
		window.addEventListener('escape', (event) => {
			this.close();
		});
	}

	/**
	 * hide search bar
     * 
     * @returns {undefined}
	 */
	 close()  {

        this.disableFocusTrap();

        document.body.classList.remove('overflow-hidden');
        document.body.classList.remove('fixed');
        document.body.classList.remove('w-full');

		this.classList.add('-translate-y-5');
		this.classList.remove('translate-y-0');
		this.classList.add('opacity-0');
		this.classList.remove('opacity-100');

		document.querySelector('[data-search-overlay]').classList.add('opacity-0');
		document.querySelector('[data-search-overlay]').classList.remove('opacity-30');

		this.closeAlgolia();

        // We need to use set time out to avoid issues with menu animation
        setTimeout(() => {

            this.setAttribute('aria-hidden', 'true');

            this.classList.add('hidden');
			this.classList.remove('block');

			document.querySelector('[data-search-overlay]').classList.add('hidden');
        }, 500);
	}

	closeAlgolia(){
		const algolia = document.querySelector('.algolia-autocomplete');
		if(algolia){
			algolia.style.display = "none";
		}
	}
	
	/**
	 * open search bar when clicking on search icon
     * 
     * @returns {undefined}
	 */
	 initOpenEvents ()  {
		let openButton = document.querySelectorAll('[data-search-open]');
        
		openButton.forEach((btn) => {

			btn.addEventListener('click', event => {
				event.preventDefault();
				this.open();
			});
		});
	}

	/**
	 * show search bar
     * 
     * @returns {undefined}
	 */
	 open() {
        this.classList.remove('hidden');
		this.classList.add('block');

        this.setAttribute('aria-hidden', 'false');

        document.querySelector('[data-search-overlay]').classList.remove('hidden');
    
        setTimeout(() => {

			document.querySelector('[data-search-overlay]').classList.remove('opacity-0');
			document.querySelector('[data-search-overlay]').classList.add('opacity-30');

			this.classList.add('translate-y-0');
			this.classList.remove('-translate-y-5');
			this.classList.add('opacity-100');
			this.classList.remove('opacity-0');

			document.body.classList.add('overflow-hidden');
			document.body.classList.add('fixed');
			document.body.classList.add('w-full');

            this.initFocusTrap();

            this.activeFocusTrap();
			
            this.querySelector('[data-search-input]').value  = "";
            this.querySelector('[data-search-input]').focus();
        }, 50);   
		
	}

	/**
	 * Init minicart focus trap
     * 
     * @returns {undefined}
	 */
     initFocusTrap ()  {

        this.focusTrap = focusTrap.createFocusTrap(this, { clickOutsideDeactivates: true });
    }

	/**
	 * Ative minicart focus trap
     * 
     * @returns {undefined}
	 */
	 activeFocusTrap ()  {

        if (this.focusTrap) {
            this.focusTrap.activate();
        }
    }

	/**
	 * Disable minicart focus trap
     * 
     * @returns {undefined}
	 */
	disableFocusTrap() {

		if (this.focusTrap) {
			this.focusTrap.deactivate();
		}
	}
}

customElements.define(customElements.component, searchBar);
}
